function compactQuery(query = {}) {
    const next = {};
    Object.entries(query).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
            return;
        }
        next[key] = value;
    });
    return next;
}

const STEPS = {
    index: '',
    paymentMethods: '/payment-methods',
    insurances: '/insurances',
    cancelingPolicies: '/canceling-policies',
    preSignin: '/pre-signin',
    login: '/login',
    register: '/register',
    patients: '/patients',
    payment: '/payment',
    pix: '/pix',
    scheduled: '/scheduled',
    pixFail: '/pix-fail',
};

export function profileQuery(vm) {
    const schedule = vm.$store.state.professionalProfile.schedule;
    const professional = schedule?.professional;

    return compactQuery({
        city: schedule?.city?.id_city ?? vm.$route.query.city ?? professional?.id_city,
        place: professional?.id_place ?? vm.$route.query.place,
        specialty: schedule?.specialty?.id_spec ?? vm.$route.query.specialty,
    });
}

export const DEFAULT_PLACE_COLOR = '#780f5a';

export function placeColor(vm) {
    return vm.$store.getters['professionalProfile/placeColor'] || DEFAULT_PLACE_COLOR;
}

export function profileTo(vm, step, extra = {}) {
    const { professionalId: extraId, ...query } = extra;
    const id = extraId
        ?? vm.$route.params.professionalId
        ?? vm.$store.state.professionalProfile.schedule.professional?.id_prof;

    return {
        path: `/professional/${id}${STEPS[step]}`,
        query: compactQuery({
            ...profileQuery(vm),
            ...query,
        }),
    };
}
